// const BASE_DOMAIN = "http://192.168.0.131:3331/"  


  
//const BASE_DOMAIN = "http://137.184.180.179:3331/"

const BASE_DOMAIN = "https://nighthawkpro.com:3331/"     


const API = {

      login: BASE_DOMAIN + 'api/v1/cms/AdminLogin',
      getAllStaffDetails: BASE_DOMAIN + 'api/v1/cms/getStaffDetails',
      createStaff: BASE_DOMAIN + 'api/v1/cms/createStaff',
      updateStaff: BASE_DOMAIN + 'api/v1/cms/updateStaff/SL_NO/',
      deleteStaff: BASE_DOMAIN + 'api/v1/cms/deleteStaff',
      createFloor: BASE_DOMAIN + 'api/v1/cms/createFloor',
      updateFloor: BASE_DOMAIN + 'api/v1/cms/updateFloor/FLOOR_ID/',
      deleteFloor: BASE_DOMAIN + 'api/v1/cms/deleteFloor',
      getAllFloor: BASE_DOMAIN + 'api/v1/cms/getAllFloor',
      getFloorAndRoomDetails: BASE_DOMAIN + 'api/v1/cms/floorAndRoomDetails',
      getDeviceAndRoomDetails: BASE_DOMAIN + 'api/v1/cms/getDeviceAndRoomDetails',
      getAllottedRoom: BASE_DOMAIN + 'api/v1/cms/getAllotedRoom',
      getAllRoom: BASE_DOMAIN + 'api/v1/cms/getAllRoom',
      getRoomByFloor: BASE_DOMAIN + 'api/v1/cms/getRoomByFloor',
      getSingleRoom: BASE_DOMAIN + 'api/v1/cms/getSingleRoom/ROOM_ID/',
      createRoom: BASE_DOMAIN + 'api/v1/cms/createRoom',
      updateRoom: BASE_DOMAIN + 'api/v1/cms/updateRoom/ROOM_ID/',
      deleteRoom: BASE_DOMAIN + 'api/v1/cms/deleteRoom',
      roomAbleorDisable: BASE_DOMAIN + 'api/v1/cms/roomAbleOrDisable',
      getPreference: BASE_DOMAIN + 'api/v1/cms/getPreference',
      createRoomPreference: BASE_DOMAIN + 'api/v1/cms/createRoomPreference',
      createDevice: BASE_DOMAIN + 'api/v1/cms/createDevice',
      updateDevice: BASE_DOMAIN + 'api/v1/cms/updateDevice/CAMERA_DATA_ID/',
      deleteDevice: BASE_DOMAIN + 'api/v1/cms/deleteDevice',
      getReport: BASE_DOMAIN + "api/v1/cms/getReport",
      createPassword: BASE_DOMAIN + "api/v1/cms/staffPassword",
      createBuilding: BASE_DOMAIN + 'api/v1/cms/createBuilding',
      getAllBuilding: BASE_DOMAIN + 'api/v1/cms/getAllBuilding',
      getSingleBuilding: BASE_DOMAIN + 'api/v1/cms/getSingleBuilding/BUILDING_ID/',
      deleteBuilding: BASE_DOMAIN + 'api/v1/cms/deleteBuilding',
      updateBuilding: BASE_DOMAIN + 'api/v1/cms/updateBuilding/BUILDING_ID/',
      getAllModules: BASE_DOMAIN + 'api/v1/cms/getModule',
      postRoleData: BASE_DOMAIN + 'api/v1/cms/createRole',
      updateRoleData: BASE_DOMAIN + 'api/v1/cms/updateRole/ROLE_ID/',
      getAllUsersData: BASE_DOMAIN + 'api/v1/cms/getUser?',
      getRoleData: BASE_DOMAIN + 'api/v1/cms/getSingleRole/ROLE_ID/',
      HandleUsersData: BASE_DOMAIN + 'api/v1/cms/getSingleUser/SL_NO/',
      createUserData: BASE_DOMAIN + 'api/v1/cms/createUser',
      updateUserData: BASE_DOMAIN + 'api/v1/cms/updateUser/SL_NO/',
      deleteUser: BASE_DOMAIN + 'api/v1/cms/deleteUser',
      deleteRole: BASE_DOMAIN + 'api/v1/cms/deleteRole',
      resetPassword: BASE_DOMAIN + 'api/v1/cms/resetPass',
      labelMe: BASE_DOMAIN + 'api/v1/cms/updateLabelMe',
      getLabelMe: BASE_DOMAIN + 'api/v1/cms/getSingleDevice/CAMERA_DATA_ID/',
      annotatedJson: BASE_DOMAIN + 'api/v1/cms/updateAnnoted',
      deleteAnnotation: BASE_DOMAIN + 'api/v1/cms/deleteJson',
      scriptStart: BASE_DOMAIN + 'api/v1/cms/triggerApi',
      //scriptStop: BASE_DOMAIN +  'api/v1/cms/stopCommand',
      scriptStop: BASE_DOMAIN + 'api/v1/cms/stopCommand',
      getImage: BASE_DOMAIN + 'api/v1/cms/getImage',
      checkCamera: BASE_DOMAIN + 'api/v1/cms/checkCamera',
      createHospital: BASE_DOMAIN +  'api/v1/cms/createHospital',
      getAllHospital: BASE_DOMAIN + 'api/v1/cms/getAllHospital',
      updateHospital: BASE_DOMAIN + 'api/v1/cms/updateHospital/HOSPITAL_ID/',
      deleteHospital: BASE_DOMAIN + 'api/v1/cms/deleteHospital',
      priorityPref: BASE_DOMAIN + 'api/v1/cms/priorityPref', 
      getPriorityPref: BASE_DOMAIN + 'api/v1/cms/getPriorityPref?hospital_id=',
      switchAccount: BASE_DOMAIN + 'api/v1/cms/getHospitalSwitch',
      getUserFromAdmin: BASE_DOMAIN + 'api/v1/cms/getUserFromAdmin',
      getSwitchBack: BASE_DOMAIN + 'api/v1/cms/getSwitchBack',
      AdminChangePassword: BASE_DOMAIN + 'api/v1/cms/AdminChangePassword',
      getNurseStation: BASE_DOMAIN + 'api/v1/cms/getCameraDetFromRole',
      getEventNotification: BASE_DOMAIN + 'api/v1/cms/getEventNotification',
      updateArrives: BASE_DOMAIN + 'api/v1/updateArrives',
      addRepositionTimer: BASE_DOMAIN + 'api/v1/cms/addRepositionTimer',
      getRepositionTimer: BASE_DOMAIN + 'api/v1/cms/getRepositionTimer',

      getLiveStream: BASE_DOMAIN + 'api/v1/cms/getLiveStream',
      getAccessEventNotification: BASE_DOMAIN + 'api/v1/cms/getAccessEventNotification'


}

export default API;